const tailLayout = {
  wrapperCol: {
    offset: 0,
    span: 16,
  },
};
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

export { layout, tailLayout };
